import type { ChartSeriesConfig } from '../types/totalAnalytics.types';

export const CHART_SERIES: ChartSeriesConfig[] = [
  {
    key: 'total',
    label: 'Total',
    color: '#1D4ED8',
    chipClass: 'border-blue-200 bg-blue-50 text-blue-700',
    strokeWidth: 3,
  },
  {
    key: 'live',
    label: 'Live',
    color: '#10B981',
    chipClass: 'border-emerald-200 bg-emerald-50 text-emerald-700',
  },
  {
    key: 'published',
    label: 'Published',
    color: '#3B82F6',
    chipClass: 'border-sky-200 bg-sky-50 text-sky-700',
  },
  {
    key: 'approved',
    label: 'Approved',
    color: '#8B5CF6',
    chipClass: 'border-violet-200 bg-violet-50 text-violet-700',
  },
  {
    key: 'expired',
    label: 'Expired',
    color: '#F59E0B',
    chipClass: 'border-amber-200 bg-amber-50 text-amber-700',
  },
  {
    key: 'rejected',
    label: 'Rejected',
    color: '#EF4444',
    chipClass: 'border-red-200 bg-red-50 text-red-700',
  },
  {
    key: 'pending',
    label: 'Pending',
    color: '#F97316',
    chipClass: 'border-orange-200 bg-orange-50 text-orange-700',
  },
  {
    key: 'cancelled',
    label: 'Cancelled',
    color: '#6B7280',
    chipClass: 'border-slate-300 bg-slate-50 text-slate-700',
  },
];

export const EMPTY_TREND_POINT = {
  name: '—',
  total: 0,
  pending: 0,
  published: 0,
  approved: 0,
  live: 0,
  expired: 0,
  rejected: 0,
  cancelled: 0,
} as const;

export const DEFAULT_AGE_BUCKETS = [
  { label: '18-24', count: 0 },
  { label: '25-34', count: 0 },
  { label: '35-44', count: 0 },
  { label: '45-54', count: 0 },
  { label: '55+', count: 0 },
];
